// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnailBar-module__container--HJUfI";
var _2 = "CarouselThumbnailBar-module__isSelected--e6XKG";
var _3 = "CarouselThumbnailBar-module__overlay--VZeHL";
var _4 = "CarouselThumbnailBar-module__placeholder--Hnhyj";
var _5 = "CarouselThumbnailBar-module__thumbnailButton--v7kAM";
export { _1 as "container", _2 as "isSelected", _3 as "overlay", _4 as "placeholder", _5 as "thumbnailButton" }
